import React, { Component } from 'react';
import Sendgoods from './senddoods';
import PickUp from './pickUp';

/**
 * 发货弹窗
 */
export class SendGoods extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        const { row, entity } = this.props;
        return (
            <div>
                {row.deliveryWay == '1' ? (
                    <PickUp rows={row} entity={entity} />
                ) : (
                    <Sendgoods rows={row} entity={entity} />
                )}
            </div>
        );
    }
}
